// extracted by mini-css-extract-plugin
export default {"fake-checkbox":"FakeCheckbox_fake-checkbox__GMBRt","icon-wrapper":"FakeCheckbox_icon-wrapper__SF7sK"};